export default "__VITE_ASSET__a7ffdc2d__"